import $ from 'jquery'


// Header scroll based classes

const el = $( '.header-sticky' );
let scrollTop = $( window ).scrollTop();
let lastScrollTop = 0;

if ( scrollTop > 50 ) {
	el.addClass( 'header-scrolled-pos' );
} else {
	el.addClass( 'header-initial-pos' );
}

$( window ).on('scroll', function( event ){
	let scrollTop = $( this ).scrollTop();

	if ( scrollTop > 50 ) {
		el.removeClass( 'header-initial-pos' ).addClass( 'header-scrolled-pos' );
	} else {
		el.removeClass( 'header-scrolled-pos' ).addClass( 'header-initial-pos' );
	}

	if ( scrollTop > lastScrollTop && scrollTop > 50 ) {
		el.removeClass( 'header-up-mov' ).addClass( 'header-down-mov' );
	} else {
		el.removeClass( 'header-down-mov' ).addClass( 'header-up-mov' );
	}

	lastScrollTop = scrollTop
})



// Header search

$( '.js-toggle-search' ).on( 'click', function( e ) {
	e.preventDefault();
	$( '.header-search' ).toggleClass( 'is-visible' );
  $( '.header-search input' ).get(0).focus();
} );

$( document ).on("keydown", function ( e ) {
	if ( e.key == "Escape" ) {
		$( '.header-search' ).removeClass( 'is-visible' );
	}
});

$( document ).on( 'click', function( e ) {
  if ( !$( '.js-toggle-search, .header-search' ).is( e.target ) && $( '.header-search' ).has( e.target ).length === 0) {
    $( '.header-search' ).removeClass( 'is-visible' );
  }
});


$('a[href^="#"]').on( 'click', function(event) {
    event.preventDefault();
    
    var target = $(this.hash);
    if (target.length) {
        $('html, body').animate({
            scrollTop: target.offset().top - 80  /* height of your sticky header */
        }, 200); // Adjust the duration as needed
    }
});